module.exports = __webpack_public_path__ + "img/trends.e6a4a293.svg";